function bpbCtInit(){

  const frame = document.getElementById('bpbCtFrame');
  const clip = document.getElementById('bpbCtClip');
  const divider = document.getElementById('bpbCtDivider');
  const labelBad = document.getElementById('bpbCtLabelBad');
  const labelGood = document.getElementById('bpbCtLabelGood');
  const listBad = document.getElementById('bpbCtListBad');
  const listGood = document.getElementById('bpbCtListGood');
  let dragging = false;
  function setPos(percent){
    percent = Math.max(4, Math.min(96, percent));
    clip.style.clipPath = 'inset(0 ' + (100 - percent) + '% 0 0)';
    divider.style.left = percent + '%';
    /* both labels only show together near the exact center; past that, only the side actually dominant is shown */
    labelBad.style.opacity = percent > 55 ? '0' : '1';
    labelBad.style.pointerEvents = percent > 55 ? 'none' : 'auto';
    labelGood.style.opacity = percent < 45 ? '0' : '1';
    labelGood.style.pointerEvents = percent < 45 ? 'none' : 'auto';
    listBad.style.opacity = percent > 55 ? '0' : '1';
    listBad.style.pointerEvents = percent > 55 ? 'none' : 'auto';
    listGood.style.opacity = percent < 45 ? '0' : '1';
    listGood.style.pointerEvents = percent < 45 ? 'none' : 'auto';
  }
  function updateFromClientX(clientX){
    const rect = frame.getBoundingClientRect();
    setPos(((clientX - rect.left) / rect.width) * 100);
  }
  frame.addEventListener('mousedown', e => { dragging = true; updateFromClientX(e.clientX); });
  window.addEventListener('mousemove', e => { if(dragging) updateFromClientX(e.clientX); });
  window.addEventListener('mouseup', () => dragging = false);
  frame.addEventListener('touchstart', e => { dragging = true; updateFromClientX(e.touches[0].clientX); }, {passive:true});
  frame.addEventListener('touchmove', e => { if(dragging) updateFromClientX(e.touches[0].clientX); }, {passive:true});
  window.addEventListener('touchend', () => dragging = false);
  setPos(50);
}

document.addEventListener('DOMContentLoaded', bpbCtInit);
document.addEventListener('shopify:section:load', bpbCtInit);